import {createReducer} from "redux-act";
import {fetchPrizesSuccess} from "modules/actions";

export interface IPrizeCard {
	title: string;
	text: string;
	img: string;
}

export interface IPrize {
	name: string;
	cards: IPrizeCard[];
}

export interface IPrizesReducer {
	prizes: IPrize[];
}

const initialState: IPrizesReducer = {
	prizes: [],
};

export const prizes = createReducer<IPrizesReducer>({}, initialState).on(
	fetchPrizesSuccess,
	(state, result) => ({
		...state,
		prizes: result,
	})
);
